module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-04-8f305645c5c120106a47276d9b5a586c.jpg";